export const debugLog = (...args: any[]) => {
  if (localStorage.getItem("debug") === "true") {
    console.log(...args)
  }
}
